// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__5ecMS","actions":"GroupTable_actions__3F1HC","deleteModalFooter":"GroupTable_deleteModalFooter__2ne19"};